<template>
  <v-layout justify-center>
    <v-flex>
      <v-card>
        <v-expansion-panel v-model="panel" popout>
          <v-expansion-panel-content
            v-for="(slidePage, i) in slidePages"
            :key="i"
            lazy
          >
            <template v-slot:header>
              <div class="title" v-text="slidePage.pageName" />
            </template>
            <v-card>
              <v-form
                v-model="slideFormValid"
                lazy-validation
                :ref="'slideForm' + i"
              >
                <v-card-text>
                  <v-container fluid grid-list-xl>
                    <v-layout wrap>
                      <v-flex xs12>
                        <v-text-field
                          label="Page name"
                          v-model="slidePage.pageName"
                          :rules="[formRules.required]"
                        />
                      </v-flex>
                      <v-flex xs12 sm3>
                        <v-switch
                          v-model="slidePage.isAuthenticationRequired"
                          label="Is authentication required"
                        />
                      </v-flex>
                      <v-flex
                        xs12
                        sm9
                        v-if="
                          appMap && appMap.items['slidePages/' + slidePage.id]
                        "
                      >
                        Caching strategy
                        <CachingStrategy
                          v-model="
                            appMap.items['slidePages/' + slidePage.id]
                              .cachingStrategy
                          "
                        />
                      </v-flex>
                      <v-flex xs12>
                        <v-card flat>
                          <v-window v-model="activeSlidePageItemIndex">
                            <v-window-item
                              v-for="(slidePageItem, j) of slidePage.items"
                              :key="j"
                            >
                              <v-card>
                                <v-layout
                                  column
                                  align-center
                                  justify-center
                                  fill-height
                                >
                                  <v-flex xs12>
                                    <v-img
                                      v-if="slidePageItem.image"
                                      :src="slidePageItem.image"
                                      contain
                                      min-width="500"
                                    />
                                    <Storage
                                      v-model="slidePageItem.image"
                                      type="slidePages"
                                    />
                                  </v-flex>
                                  <v-flex xs12>
                                    <v-text-field
                                      label="Title"
                                      v-model="slidePageItem.title"
                                    />
                                    <v-text-field
                                      label="Subtitle"
                                      v-model="slidePageItem.subTitle"
                                    />
                                  </v-flex>
                                  <v-flex xs12>
                                    <v-card
                                      v-for="(actionItem,
                                      k) of slidePageItem.actionItems"
                                      :key="k"
                                      class="mb-2"
                                    >
                                      <v-card-text>
                                        <v-text-field
                                          label="Text"
                                          v-model="actionItem.text"
                                        />
                                        <icon-picker
                                          v-model="actionItem.icon"
                                        />
                                        <v-layout row wrap>
                                          <v-flex xs12 sm4>
                                            <ActionType
                                              v-model="actionItem.action.type"
                                            />
                                          </v-flex>
                                          <v-flex xs12 sm6>
                                            <ActionLink
                                              v-model="actionItem.action.link"
                                              :type="actionItem.action.type"
                                              @clearLink="
                                                $delete(
                                                  actionItem.action,
                                                  'link'
                                                )
                                              "
                                            />
                                          </v-flex>
                                          <v-flex xs12 sm2>
                                            <v-btn
                                              @click="
                                                slidePageItem.actionItems.splice(
                                                  k,
                                                  1
                                                )
                                              "
                                              icon
                                            >
                                              <v-icon
                                                v-text="fa('trash-alt')"
                                              ></v-icon>
                                            </v-btn>
                                          </v-flex>
                                        </v-layout>
                                      </v-card-text>
                                    </v-card>
                                    <v-btn
                                      block
                                      @click="
                                        slidePageItem.actionItems.push({
                                          action: {
                                            type: 'NONE'
                                          }
                                        })
                                      "
                                    >
                                      <v-icon v-text="fa('plus')"></v-icon>
                                      Add action item
                                    </v-btn>
                                  </v-flex>
                                  <v-flex xs12>
                                    <v-btn
                                      flat
                                      round
                                      @click="
                                        slidePage.items.splice(
                                          j - 1,
                                          0,
                                          slidePageItem
                                        );
                                        slidePage.items.splice(j + 1, 1);
                                      "
                                      :disabled="loading"
                                      v-if="j > 0"
                                    >
                                      <v-icon
                                        v-text="fa('angle-left')"
                                      ></v-icon>
                                      Move before
                                    </v-btn>
                                    <v-btn
                                      flat
                                      color="warning"
                                      @click="
                                        removeSlidePageItem(
                                          slidePage,
                                          slidePageItem
                                        )
                                      "
                                      :disabled="loading"
                                      >Remove slide page item</v-btn
                                    >
                                    <v-btn
                                      flat
                                      @click="
                                        slidePage.items.splice(j, 1);
                                        slidePage.items.splice(
                                          j + 1,
                                          0,
                                          slidePageItem
                                        );
                                      "
                                      :disabled="loading"
                                      v-if="j < slidePage.items.length - 1"
                                    >
                                      Move after
                                      <v-icon
                                        v-text="fa('angle-right')"
                                      ></v-icon>
                                    </v-btn>
                                  </v-flex>
                                </v-layout>
                              </v-card>
                            </v-window-item>
                          </v-window>

                          <v-card-actions class="justify-center mt-3">
                            <v-item-group
                              v-model="activeSlidePageItemIndex"
                              class="text-xs-center"
                              mandatory
                            >
                              <v-item
                                v-for="(slidePageItem, j) of slidePage.items"
                                :key="j"
                              >
                                <v-btn
                                  slot-scope="{ active, toggle }"
                                  :input-value="active"
                                  icon
                                  @click="toggle"
                                >
                                  <v-icon v-text="fa('circle')"></v-icon>
                                </v-btn>
                              </v-item>
                            </v-item-group>
                          </v-card-actions>
                          <v-card-actions>
                            <v-btn
                              block
                              @click="addSlidePageItem(slidePage)"
                              :disabled="loading"
                            >
                              <v-icon v-text="fa('plus')"></v-icon>
                              Add slide page item
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-btn
                    color="warning"
                    flat
                    @click="remove(slidePage)"
                    :disabled="loading"
                    >Remove</v-btn
                  >
                  <v-spacer />
                  <v-btn
                    color="primary"
                    @click="save(slidePage, i)"
                    :disabled="loading"
                    >Save</v-btn
                  >
                </v-card-actions>
              </v-form>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-card-actions>
          <v-layout row align-center justify-center wrap>
            <v-flex xs3>
              <v-text-field label="Name" v-model="newSlidePageName" />
            </v-flex>
            <v-flex xs3>
              <v-btn
                @click="addSlidePage"
                color="primary"
                :disabled="loading || !newSlidePageName"
              >
                <v-icon v-text="fa('calendar-day')"></v-icon>
                Add a slide page
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import firebase from "@firebase/app";
import { db } from "../../plugins/firebase";
import { appMapSuffix, eventHub } from "../../config/constants";
import CachingStrategy from "../../components/CachingStrategy";
import ActionType from "../../components/ActionType";
import ActionLink from "../../components/ActionLink";
import Storage from "../../components/Storage";
const slidePagesCollection = db.collection("slidePages");

export default {
  name: "SlidePages",
  components: {
    CachingStrategy,
    ActionType,
    ActionLink,
    Storage
  },
  data: () => ({
    slideFormValid: true,
    newSlidePageName: null,
    loading: false,
    slidePages: [],
    panel: null,
    appMap: null,
    activeSlidePageItemIndex: 0
  }),
  watch: {
    "$route.params.language": {
      immediate: true,
      handler(language) {
        this.$bind(
          "slidePages",
          slidePagesCollection.where("language", "==", String(language))
        );
        this.$bind(
          "appMap",
          db.collection("appMaps").doc(language + appMapSuffix)
        );
      }
    },
    async slidePages(slidePages) {
      if (slidePages.length) {
        if (this.$route.params.slidePage) {
          this.panel = slidePages.findIndex(
            slidePage => this.$route.params.slidePage === slidePage.id
          );
        }
      }
    },
    panel(value) {
      if (
        !this.$route.params.slidePage ||
        (this.slidePages[value]
          ? this.$route.params.slidePage !== this.slidePages[value].id
          : true)
      ) {
        this.activeSlidePageItemIndex = 0;
        this.$router.replace({
          params: {
            slidePage: this.slidePages[value] ? this.slidePages[value].id : null
          }
        });
      }
    }
  },
  methods: {
    async addSlidePage() {
      this.panel = null;
      this.loading = true;
      try {
        await db.runTransaction(async t => {
          const newSlidePage = slidePagesCollection.doc();
          t.set(newSlidePage, {
            language: this.$route.params.language,
            pageName: this.newSlidePageName,
            type: "SLIDE_PAGE",
            isAuthenticationRequired: false,
            items: []
          }).set(
            this.$firestoreRefs.appMap,
            {
              items: {
                ["slidePages/" + newSlidePage.id]: {
                  cachingStrategy: "ON_OPEN",
                  isAuthenticationRequired: false,
                  name: this.newSlidePageName,
                  type: "SLIDE_PAGE",
                  version: 1
                }
              }
            },
            {
              merge: true
            }
          );
        });
        eventHub.$emit("message", "green");
        this.newSlidePageName = null;
      } catch (error) {
        eventHub.$emit("message", "red", error.code);
      }
      this.loading = false;
    },
    async save(slidePage, i) {
      if (!this.$refs["slideForm" + i][0].validate()) {
        return;
      }
      this.loading = true;
      try {
        await db.runTransaction(async t => {
          t.set(slidePagesCollection.doc(slidePage.id), slidePage);
          t.set(this.$firestoreRefs.appMap, this.appMap);
        });
        eventHub.$emit("message", "green");
      } catch (error) {
        eventHub.$emit("message", "red", error.code);
      }
      this.loading = false;
    },
    async remove(slidePage) {
      this.loading = true;
      const appMapItem = this.appMap.items["slidePages/" + slidePage.id];
      try {
        await db.runTransaction(async t => {
          t.delete(slidePagesCollection.doc(slidePage.id));
          delete this.appMap.items["slidePages/" + slidePage.id];
          t.update(this.$firestoreRefs.appMap, this.appMap);
        });
        eventHub.$emit("message", "green");
      } catch (error) {
        this.appMap.items["slidePages/" + slidePage.id] = appMapItem;
        eventHub.$emit("message", "red", error.code);
      }
      this.loading = false;
    },
    async addSlidePageItem(slidePage) {
      this.loading = true;
      try {
        await db.runTransaction(async t =>
          t.update(
            slidePagesCollection.doc(slidePage.id),
            "items",
            firebase.firestore.FieldValue.arrayUnion({
              title: null,
              image: null,
              actionItems: []
            })
          )
        );
        eventHub.$emit("message", "green");
      } catch (error) {
        eventHub.$emit("message", "red", error.code);
      }
      this.loading = false;
    },
    async removeSlidePageItem(slidePage, slidePageItem) {
      this.loading = true;
      try {
        await db.runTransaction(async t =>
          t.update(
            slidePagesCollection.doc(slidePage.id),
            "items",
            firebase.firestore.FieldValue.arrayRemove(slidePageItem)
          )
        );
        eventHub.$emit("message", "green");
      } catch (error) {
        eventHub.$emit("message", "red", error.code);
      }
      this.loading = false;
    }
  }
};
</script>
